import React from "react";
import type { ConditionConfiguration } from "../../../../../../../../api/types/fieldConfigurationTypes.ts";
import type {
  ConditionField,
  ReportField,
  RunPivotReportRequest,
  SortField,
} from "../../../../../../../../api/types/svTypes.ts";
import { useBiCommonDataContext } from "../../../../contexts/BiCommonDataContext.ts";

interface Props {
  values: ReportField[];
  sorts: SortField[];
  isQueryLoggingActive: boolean | undefined;
  sessionId: string;
}
export function useRequestConfigViewer({ isQueryLoggingActive, values, sessionId, sorts }: Props) {
  const { reportId, conditions } = useBiCommonDataContext();

  const requestConfig = React.useMemo(() => {
    const request: RunPivotReportRequest = {
      conditions: getConditions(conditions, values),
      sort: sorts.map((s) => s.config),
      reportId: reportId || "",
      sessionId,
      withDrilldown: true,
      useQueryLogging: isQueryLoggingActive === true,
    };
    return request;
  }, [conditions, sessionId, reportId, isQueryLoggingActive, values, sorts]);

  return { requestConfig };
}

function getConditions(allConditions: ConditionField[], values: ReportField[]) {
  const customConditions = values
    .filter((f) => f.config?.useCustomConditions && f.config?.customConditions)
    .map((f) => f.config?.customConditions)
    .flat()
    .filter((c): c is ConditionConfiguration => c !== undefined);

  const conditions = [
    ...allConditions.map((c) => ({ ...c.config, invalid: c.validation?.invalid })),
    ...customConditions,
  ].filter((c) => c.parameter === true);
  return conditions;
}
